






























































































import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { ProductSampleGroup, ProductSample, ProductSampleRequest } from '@/models/ProductSampleGroup';
import { CustomField, CustomFieldData } from '@/models/Contact'; 
import DynamicForm from '@/components/Form/DynamicForm.vue'; 
import SingleSelect from '@/components/SingleSelect.vue';
import { websiteText } from '@/mixins/websiteTexts';

declare var grecaptcha: any;

@Component({
    components: {
        SingleSelect,
        DynamicForm
    }
})
export default class ProductSampleForm extends Vue {
    [x: string]: any;
    private sampleGroups!: ProductSampleGroup[];
    protected selectedProducts: string[] = [];
    protected isLoaded: boolean = false;
    protected isSubmitted: boolean = false;

    private errorMsgs: string[] = [];
    private gdprTitle: string;
    private gdprText: '';
    private recaptchaString: string;

    constructor() {
        super();
        this.sampleGroups = JSON.parse(this.$attrs['data-sample-groups']);
        this.$attrs['data-sample-groups'] = '';
        this.gdprTitle = this.$attrs['data-gdpr-title'];
        this.gdprText = JSON.parse(this.$attrs['data-gdpr-text']);
        this.recaptchaString = this.$attrs['data-recaptcha-site-key'];
        this.$attrs['data-gdpr-text'] = '';
        this.$attrs['data-gdpr-title'] = '';
        this.$attrs['data-recaptcha-site-key'] = '';
    }

    get formSchema(): CustomField[] {
        return [
            { placeholder: websiteText('retailer.firstName'), fieldType: 'TextField', mandatory: true, tabIndex: 1 },
            { placeholder: websiteText('retailer.lastName'), fieldType: 'TextField', mandatory: true, tabIndex: 2 },
            { placeholder: websiteText('retailer.organizationNumber'), fieldType: 'TextField', mandatory: true, tabIndex: 3 },
            { placeholder: websiteText('retailer.emailaddress'), fieldType: 'EmailField', mandatory: true, tabIndex: 4 },
            { placeholder: websiteText('retailer.cellphone'), fieldType: 'TextField', mandatory: true, tabIndex: 5 },
            { placeholder: websiteText('retailer.address'), fieldType: 'TextField', mandatory: true, tabIndex: 6 },
            { placeholder: websiteText('retailer.zipcode'), fieldType: 'TextField', mandatory: true, tabIndex: 7 },
            { placeholder: websiteText('retailer.city'), fieldType: 'TextField', mandatory: true, tabIndex: 8 },
            { placeholder: websiteText('retailer.country'), fieldType: 'TextField', mandatory: true, tabIndex: 9 },
            { placeholder: websiteText('retailer.projectdepartmentmessage'), fieldType: 'MultirowTextField', mandatory: false, tabIndex: 10 },
            { 
                placeholder: websiteText('general.approve'), 
                fieldType: 'CheckboxField', 
                options: [{ text: websiteText('site.policy'), value: 'true' }], 
                mandatory: true, 
                tabIndex: 11 
            }
        ];
    }

    private selectSampleGroup(i: number) {
        const temp = [...this.sampleGroups];
        temp[i].isOpen = !this.sampleGroups[i].isOpen;
        this.sampleGroups = temp;
    }
    private toggleError(group: ProductSampleGroup, i: number) {
        const temp = [...this.sampleGroups];
        temp[i].toggleError = !this.sampleGroups[i].toggleError;
        this.sampleGroups = temp;
    }
    private selectSample(e: Event, s: any, i: number) {
        const temp = [...this.sampleGroups];
        const selectedSample = temp[i].productSamples.find(x => x.id === s.id);
        if (selectedSample) {
            selectedSample.selected = (e.target as HTMLInputElement).checked;
        }
        if((e.target as HTMLInputElement).checked && this.errorMsgs.length > 0) {
            this.errorMsgs = [];
        }
        this.sampleGroups = temp;
    }
 
    private submitForm(formData: CustomFieldData[]) {
        this.errorMsgs = [];
        this.selectedProducts = [];
        
        this.sampleGroups.forEach(v => {
            v.productSamples.filter(x => x.selected).forEach(vv => {
                this.selectedProducts.push(vv.id);
            });
        });

        if (this.selectedProducts.length === 0) {
            this.errorMsgs.push(websiteText('retailer.error.nosample')); 
            return;
        }

        this.isSubmitted = true;
        const recaptchaSiteKey = this.recaptchaString;
        const submitCallback = this.executeApiCall;

        grecaptcha.ready(function() {
            grecaptcha
                .execute(recaptchaSiteKey, { action: 'submit' })
                .then(function(token: string) {
                    submitCallback(token, formData);
                });
        });
    }

    private executeApiCall(token: string, formData: CustomFieldData[]) {
        const request: ProductSampleRequest = {
            Token: token,
            Products: this.selectedProducts,
            FirstName: formData[0].value,
            LastName: formData[1].value,
            OrganizationNumber: formData[2].value,
            Mail: formData[3].value,
            Phone: formData[4].value,
            Address: formData[5].value,
            ZipCode: formData[6].value,
            City: formData[7].value,
            Country: formData[8].value,
            Message: formData[9].value,
            ConcentPolicy: formData[10].value === 'true',
            NewsLetter: false
        };

        const requestContext = (window as any).__litium.requestContext;

        axios({
            method: 'post',
            url: `/api/productsample`,
            data: request,
            headers: {
                'litium-request-context': JSON.stringify(requestContext)
            }
        })
        .then((response: any) => {
            const self = this;
            setTimeout(function() {
                self.isLoaded = true;
            }, 600);
        })
        .catch((response: any) => {
            this.isSubmitted = false;
            this.errorMsgs.push('An error occurred. Please try again.');
        });
    }
    //animate
    private enter(element: HTMLElement) {
        const width = getComputedStyle(element).width;

        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const height = getComputedStyle(element).height;

        element.style.width = '';
        element.style.position = '';
        element.style.visibility = '';
        element.style.height = '0';
        getComputedStyle(element).height;
        requestAnimationFrame(() => {
            element.style.height = height;
        });
    }
    private afterEnter(element: HTMLElement) {
        element.style.height = 'auto';
    }
    private leave(element: HTMLElement) {
        const height = getComputedStyle(element).height;

        element.style.height = height;
        getComputedStyle(element).height;
        requestAnimationFrame(() => {
            element.style.height = '0';
        });
    }
    //end animate
    private numberOfArticles(samples: ProductSample[], onlySelected: boolean): number {
        if (onlySelected) return samples.filter(x => x.selected).length;
        return samples.length;
    }
}
